import axios from 'axios'
import { Notification, MessageBox, Message, Loading } from 'element-ui'
// import store from '@/store'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { tansParams, blobValidate } from '@/utils/ruoyi'
import cache from '@/utils/cache.js'
import { saveAs } from 'file-saver'
import store from '@/store'

let downloadLoadingInstance
// 是否显示重新登录
export let isRelogin = { show: false }

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 60000 * 5
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    if (getToken() && !isToken) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?' + tansParams(config.params)
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
      const requestObj = {
        url: config.url,
        data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
        time: new Date().getTime()
      }
      const sessionObj = cache.session.getJSON('sessionObj')
      if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
        cache.session.setJSON('sessionObj', requestObj)
      } else {
        const s_url = sessionObj.url // 请求地址
        const s_data = sessionObj.data // 请求数据
        const s_time = sessionObj.time // 请求时间
        const interval = 1000 // 间隔时间(ms)，小于此时间视为重复提交
        // if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        //   const message = '数据正在处理，请勿重复提交'
        //   console.warn(`[${s_url}]: ` + message)
        //   return Promise.reject(new Error(message))
        // } else {
        //   cache.session.setJSON('sessionObj', requestObj)
        // }
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      return res.data
    }
    if (code === 401) {
      if (!isRelogin.show) {
        isRelogin.show = true
        MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            isRelogin.show = false
            store.dispatch('openLogin', true)
            //   store.dispatch('LogOut').then(() => {
            //     location.href = '/index';
            //   })
          })
          .catch(() => {
            isRelogin.show = false
          })
      }
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
      Message({ message: msg, type: 'error' })
      return Promise.reject(new Error(msg))
    } else if (code === 601) {
        return res.data;
        // return Promise.reject('error')
    } else if (code !== 200) {
      if (code === 501 || code === 502) {
        return res.data
      }
      Notification.error({ title: msg })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  (error) => {
    console.log('err: ',  error)
    let { message } = error
    if (message == 'Network Error') {
      message = '后端接口连接异常'
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时'
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常'
    } else if (message == '数据正在处理，请勿重复提交') {
      message = '数据正在处理，请勿重复提交'
    } else if (message.includes('canceled')) {
      message = ''
    } else {
      message = '系统接口异常'
    }
    if (message) {
      Message({ message: message, type: 'error', duration: 5 * 1000 })
    }
    return Promise.reject(error)
  }
)

// 通用下载方法
export function download(url, params, filename, config) {
  downloadLoadingInstance = Loading.service({
    text: '正在下载数据，请稍候',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  return service
    .post(url, params, {
      transformRequest: [
        (params) => {
          return tansParams(params)
        }
      ],
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'blob',
      ...config
    })
    .then(async (data) => {
      const isBlob = blobValidate(data)
      if (isBlob) {
        const blob = new Blob([data])
        saveAs(blob, filename)
      } else {
        const resText = await data.text()
        const rspObj = JSON.parse(resText)
        const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
        Message.error(errMsg)
      }
      downloadLoadingInstance.close()
    })
    .catch((r) => {
      console.error(r)
      Message.error('下载文件出现错误，请联系管理员！')
      downloadLoadingInstance.close()
    })
}

// 处理 SSE 缓冲区 - 按消息分割
export function processSSEBuffer(buffer, callback) {
  // 按空行分割 SSE 消息
  const messages = buffer.split(/\n\n/);
  let remainingBuffer = messages.pop() || '';
  
  for (const message of messages) {
    if (message.trim()) {
      parseSSEMessage(message.trim(), callback);
    }
  }
  
  return remainingBuffer;
}

// 解析 SSE 消息
function parseSSEMessage(message, callback) {
  const lines = message.split('\n');
  let eventData = {
    event: 'message',
    data: '',
    id: null,
    retry: null
  };
  
  // 解析 SSE 字段
  for (const line of lines) {
    if (!line.trim()) continue;
    
    const colonIndex = line.indexOf(':');
    if (colonIndex === -1) {
      // 没有冒号，可能是纯数据
      eventData.data += line;
      continue;
    }
    
    const field = line.slice(5).substring(0, colonIndex).trim();
    let value = line.slice(5).substring(colonIndex + 1).trim();
    
    // 处理前置空格（SSE规范允许）
    if (value.startsWith(' ')) {
      value = value.substring(1);
    }
    
    switch (field) {
      case 'event':
        eventData.event = value;
        break;
      case 'data':
        // 数据可能跨越多行
        eventData.data += (eventData.data ? '\n' : '') + value;
        break;
      case 'id':
        eventData.id = value;
        break;
      case 'retry':
        eventData.retry = parseInt(value, 10) || null;
        break;
      default:
        // 忽略未知字段
        break;
    }
  }
  
  // 处理数据
  if (eventData.data) {
    try {
      const parsedData = JSON.parse(eventData.data);
      
      if (parsedData.type === 'end') {
        // 结束消息
        callback(null, parsedData.data || [], '');
      } else {
        // 数据消息
        const content = cleanText(parsedData.data || parsedData.content || '');
        callback(content, '');
      }
    } catch (e) {
      // 不是 JSON，作为纯文本处理
      console.warn('解析 JSON 失败，作为文本处理:', e, '数据:', eventData.data.substring(0, 100));
      const content = cleanText(eventData.data);
      callback(content, [], '');
    }
  }
}

// 处理缓冲区内容（用于结束时的处理）
function processBufferContent(buffer, callback) {
  const lines = buffer.split('\n');
  let sseBuffer = '';
  
  for (const line of lines) {
    if (line.trim() === '') {
      // 空行表示消息结束
      if (sseBuffer.trim()) {
        parseSSEMessage(sseBuffer.trim(), callback);
        sseBuffer = '';
      }
    } else {
      sseBuffer += line + '\n';
    }
  }
  
  // 处理最后的消息（如果没有空行结尾）
  if (sseBuffer.trim()) {
    parseSSEMessage(sseBuffer.trim(), callback);
  }
}

// 改进的文本清理函数
export function cleanText(text) {
  if (!text || typeof text !== 'string') {
    return '';
  }

  // 1. 移除 Unicode 替换字符
  let cleaned = text.replace(/\ufffd/g, '').replace(/\uFFFD/g, '');

  // 2. 移除控制字符（保留 \n, \r, \t）
  cleaned = cleaned.replace(/[\x00-\x09\x0B\x0C\x0E-\x1F\x7F-\x9F]/g, '');

  // 3. 智能修复 UTF-8 截断
  cleaned = fixUtf8Truncation(cleaned);

  return cleaned;
}

// 智能修复 UTF-8 截断
function fixUtf8Truncation(text) {
  if (!text.includes('�')) {
    return text;
  }
  
  let result = text;
  
  // 修复已知模式
  const knownPatterns = [
    ['分��', '分析'],
    ['铜��', '铜锡'],
    ['物��', '物']
  ];
  
  for (const [pattern, replacement] of knownPatterns) {
    result = result.replace(new RegExp(pattern, 'g'), replacement);
  }
  
  // 通用修复：移除单独的 ��
  result = result.replace(/�+/g, '');
  
  // 修复中文字符后的乱码
  result = result.replace(/([\u4e00-\u9fa5])�+/g, '$1');
  
  // 修复乱码对
  result = result.replace(/�{2,}/g, '');
  
  return result;
}

// 辅助调试函数
function debugSSE(chunk, buffer) {
  console.group('SSE 调试信息');
  console.log('收到 chunk 长度:', chunk.length);
  console.log('chunk 内容:', chunk);
  console.log('当前 buffer:', buffer);
  console.log('包含乱码:', chunk.includes('�'));
  console.groupEnd();
}

export default service
